"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const axios_1 = __importDefault(require("axios"));
const vue_property_decorator_1 = require("vue-property-decorator");
const Paginado_vue_1 = __importDefault(require("./Paginado.vue"));
const Resultado_vue_1 = __importDefault(require("./Resultado.vue"));
const Preloader_vue_1 = __importDefault(require("./Preloader.vue"));
const SinResultados_vue_1 = __importDefault(require("./SinResultados.vue"));
let Resultados = class Resultados extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.page = 1;
        this.orden = "destacado";
        this.loading = true;
        this.paginado = {};
        this.resultados = [];
    }
    created() {
        this.buscar();
    }
    onPageChanged() {
        this.buscar();
    }
    onOrdenChanged() {
        this.page = 1;
        this.buscar();
    }
    onFiltrosChanged() {
        this.page = 1;
        this.buscar();
    }
    buscar() {
        this.loading = true;
        this.paginado = {};
        this.resultados = [];
        let params = lodash_1.default.pickBy(this.filtros, (param, key) => {
            if (typeof param === "object") {
                return param.length > 0;
            }
            return param;
        });
        if (params.precio[0] === this.filtrosPrevios.precio[0] &&
            params.precio[1] === this.filtrosPrevios.precio[1]) {
            delete params.precio;
        }
        if (params.antiguedad[0] === this.filtrosPrevios.antiguedad[0] &&
            params.antiguedad[1] === this.filtrosPrevios.antiguedad[1]) {
            delete params.antiguedad;
        }
        if (params.superficie_total[0] === this.filtrosPrevios.superficie_total[0] &&
            params.superficie_total[1] === this.filtrosPrevios.superficie_total[1]) {
            delete params.superficie_total;
        }
        if (params.superficie_cubierta[0] ===
            this.filtrosPrevios.superficie_cubierta[0] &&
            params.superficie_cubierta[1] ===
                this.filtrosPrevios.superficie_cubierta[1]) {
            delete params.superficie_cubierta;
        }
        params.page = this.page;
        params.orden = this.orden;
        axios_1.default
            .get("/api/inmuebles/resultados", { params })
            .then((response) => {
            this.paginado = response.data.meta;
            this.resultados = response.data.data;
            this.loading = false;
        })
            .catch((error) => {
            this.$bvToast.toast(error, {
                title: `Error`,
                variant: `danger`,
                solid: true,
            });
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], Resultados.prototype, "filtros", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], Resultados.prototype, "filtrosPrevios", void 0);
__decorate([
    vue_property_decorator_1.Watch("page", { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Resultados.prototype, "onPageChanged", null);
__decorate([
    vue_property_decorator_1.Watch("orden", { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Resultados.prototype, "onOrdenChanged", null);
__decorate([
    vue_property_decorator_1.Watch("filtros", { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Resultados.prototype, "onFiltrosChanged", null);
Resultados = __decorate([
    vue_property_decorator_1.Component({ components: { Paginado: Paginado_vue_1.default, Resultado: Resultado_vue_1.default, Preloader: Preloader_vue_1.default, SinResultados: SinResultados_vue_1.default } })
], Resultados);
exports.default = Resultados;
